var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientBenefitsCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.518 6.55518H1.52413C1.2243 6.55518 1.02441 6.36789 1.02441 6.08696V0.468227C1.02441 0.187291 1.2243 0 1.52413 0H12.518C12.8178 0 13.0177 0.187291 13.0177 0.468227V6.08696C13.0177 6.36789 12.8178 6.55518 12.518 6.55518ZM2.02385 5.61873H12.0183V0.936455H2.02385V5.61873Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02113 5.15051C6.17161 5.15051 5.52197 4.3077 5.52197 3.2776C5.52197 2.2475 6.17161 1.40469 7.02113 1.40469C7.87066 1.40469 8.52029 2.2475 8.52029 3.2776C8.52029 4.3077 7.87066 5.15051 7.02113 5.15051Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9672 7.25752C13.8672 7.11706 13.7173 7.02341 13.5174 7.02341C12.418 7.02341 11.3686 7.49164 10.719 8.33445L10.2692 8.89632C9.71956 9.50502 8.87003 9.83278 8.02051 9.83278H6.52135C6.22152 9.83278 6.02163 9.64548 6.02163 9.36455C6.02163 9.08361 6.22152 8.89632 6.52135 8.89632H7.47082C8.27037 8.89632 9.01995 8.28763 9.01995 7.53846V7.49164C9.01995 7.25752 8.77009 7.02341 8.52023 7.02341H5.47193C3.67294 7.02341 2.22375 7.77258 1.4242 8.98997L0.074958 10.9565C-0.024986 11.097 -0.024986 11.2843 0.074958 11.4247L1.57412 13.7659C1.62409 13.8595 1.77401 13.9532 1.87395 14C1.92392 14 1.92392 14 1.97389 14C2.07384 14 2.17378 13.9532 2.27373 13.9064C4.17266 12.7358 6.37143 12.1271 8.62017 12.1271C10.2692 12.1271 11.7684 11.2843 12.568 9.92642L13.9172 7.67893C14.0171 7.58528 14.0171 7.39799 13.9672 7.25752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52417 0.468231V2.80937C2.92339 2.80937 4.02277 1.77927 4.02277 0.468231H1.52417Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52417 6.08696H4.02277C4.02277 4.77592 2.92339 3.74582 1.52417 3.74582V6.08696Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.518 6.08696V3.74582C11.1188 3.74582 10.0194 4.77592 10.0194 6.08696H12.518Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.518 0.468231H10.0194C10.0194 1.77927 11.1188 2.80937 12.518 2.80937V0.468231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientBenefitsCheckIcon);
export default __webpack_public_path__ + "static/media/PatientBenefitsCheckIcon.aeae9b68e6c637570522e863a9ee7309.svg";
export { ForwardRef as ReactComponent };